import { render, staticRenderFns } from "./edit_move.vue?vue&type=template&id=3f917a3f&scoped=true&"
import script from "./edit_move.vue?vue&type=script&lang=js&"
export * from "./edit_move.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f917a3f",
  null
  
)

export default component.exports